<section class="main-section">
  <nav aria-label="breadcrumb">
    <nav class="breadcrumb" aria-label="breadcrumb">
      <ol class="breadcrumb p-3">
        <li class="breadcrumb-item"><a routerLink="/admin/dashboard/">Home</a></li>
        <li class="breadcrumb-item"><a routerLink="/admin/credits/">Credits</a></li>
        <li class="breadcrumb-item active" aria-current="page">Credits Report</li>
      </ol>
    </nav>
  </nav>


  <form>
    <div class="row mt-3">
      <div class="col">
        <div class="inner-box">
          <div class="row">
            <div class="col-6">

              <h5 class="mb-3 p-2"> <span class="stepsIcons p-2">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M1.35288 13.0496L0.622697 13.2209L1.35288 13.0496ZM1.35288 6.95043L0.622697 6.77915L1.35288 6.95043ZM18.6471 6.95044L17.9169 7.12171L18.6471 6.95044ZM18.6471 13.0496L17.9169 12.8783L18.6471 13.0496ZM13.0496 18.6471L12.8783 17.9169L13.0496 18.6471ZM6.95044 18.6471L6.77916 19.3773L6.95044 18.6471ZM6.95043 1.35288L6.77916 0.622696L6.95043 1.35288ZM13.0496 1.35288L12.8783 2.08306L13.0496 1.35288ZM5.8491 6.86899C5.55621 6.5761 5.08134 6.57609 4.78844 6.86899C4.49555 7.16188 4.49555 7.63675 4.78844 7.92965L5.8491 6.86899ZM6.35904 8.43959L5.82871 8.96992C5.96937 9.11057 6.16013 9.18959 6.35904 9.18959C6.55796 9.18959 6.74872 9.11057 6.88937 8.96992L6.35904 8.43959ZM8.96992 6.88938C9.26281 6.59648 9.26281 6.12161 8.96992 5.82872C8.67703 5.53582 8.20215 5.53582 7.90926 5.82872L8.96992 6.88938ZM11.0403 7.16946C10.6261 7.16946 10.2903 7.50524 10.2903 7.91946C10.2903 8.33367 10.6261 8.66946 11.0403 8.66946V7.16946ZM14.6812 8.66946C15.0954 8.66946 15.4312 8.33367 15.4312 7.91946C15.4312 7.50524 15.0954 7.16946 14.6812 7.16946V8.66946ZM5.8491 12.0704C5.55621 11.7775 5.08134 11.7775 4.78844 12.0704C4.49555 12.3632 4.49555 12.8381 4.78844 13.131L5.8491 12.0704ZM6.35904 13.641L5.82871 14.1713C6.12161 14.4642 6.59648 14.4642 6.88937 14.1713L6.35904 13.641ZM8.96992 12.0907C9.26281 11.7978 9.26281 11.323 8.96992 11.0301C8.67703 10.7372 8.20215 10.7372 7.90926 11.0301L8.96992 12.0907ZM11.0403 12.3708C10.6261 12.3708 10.2903 12.7066 10.2903 13.1208C10.2903 13.535 10.6261 13.8708 11.0403 13.8708V12.3708ZM14.6812 13.8708C15.0954 13.8708 15.4312 13.535 15.4312 13.1208C15.4312 12.7066 15.0954 12.3708 14.6812 12.3708V13.8708ZM2.08306 12.8783C1.63898 10.9851 1.63898 9.01488 2.08306 7.12171L0.622697 6.77915C0.125768 8.89763 0.125768 11.1024 0.622697 13.2209L2.08306 12.8783ZM17.9169 7.12171C18.361 9.01488 18.361 10.9851 17.9169 12.8783L19.3773 13.2208C19.8742 11.1024 19.8742 8.89764 19.3773 6.77916L17.9169 7.12171ZM12.8783 17.9169C10.9851 18.361 9.01488 18.361 7.12171 17.9169L6.77916 19.3773C8.89764 19.8742 11.1024 19.8742 13.2208 19.3773L12.8783 17.9169ZM7.12171 2.08306C9.01488 1.63898 10.9851 1.63898 12.8783 2.08306L13.2208 0.622696C11.1024 0.125768 8.89763 0.125768 6.77916 0.622696L7.12171 2.08306ZM7.12171 17.9169C4.62161 17.3305 2.6695 15.3784 2.08306 12.8783L0.622697 13.2209C1.33924 16.2756 3.72441 18.6608 6.77916 19.3773L7.12171 17.9169ZM13.2208 19.3773C16.2756 18.6608 18.6608 16.2756 19.3773 13.2208L17.9169 12.8783C17.3305 15.3784 15.3784 17.3305 12.8783 17.9169L13.2208 19.3773ZM12.8783 2.08306C15.3784 2.6695 17.3305 4.62161 17.9169 7.12171L19.3773 6.77916C18.6608 3.72441 16.2756 1.33924 13.2208 0.622696L12.8783 2.08306ZM6.77916 0.622696C3.72441 1.33924 1.33924 3.72441 0.622697 6.77915L2.08306 7.12171C2.6695 4.6216 4.62161 2.6695 7.12171 2.08306L6.77916 0.622696ZM4.78844 7.92965L5.82871 8.96992L6.88937 7.90926L5.8491 6.86899L4.78844 7.92965ZM6.88937 8.96992L8.96992 6.88938L7.90926 5.82872L5.82871 7.90926L6.88937 8.96992ZM11.0403 8.66946H14.6812V7.16946H11.0403V8.66946ZM4.78844 13.131L5.82871 14.1713L6.88937 13.1106L5.8491 12.0704L4.78844 13.131ZM6.88937 14.1713L8.96992 12.0907L7.90926 11.0301L5.82871 13.1106L6.88937 14.1713ZM11.0403 13.8708H14.6812V12.3708H11.0403V13.8708Z"
              fill="#9E9E9E"/>
            </svg>
         </span>Credits Report
              </h5>
            </div>


            <div class="row mx-2">
              <div class="col-6 form-group">
                <label class="control-label" for="startDate">Start Date</label>
                <input (blur)="typeStartError()" type="date" id="startDate" [(ngModel)]="startDate"
                       [ngModelOptions]="{standalone: true}"
                       class="form-control " required>
              </div>

              <div class="col-6 form-group">
                <label class="control-label" for="endDate">End Date</label>
                <input (blur)="typeEndError()" type="date" id="endDate" [(ngModel)]="endDate"
                       [ngModelOptions]="{standalone: true}"
                       class="form-control " required>
              </div>
            </div>


            <div class="d-flex flex-row">

              <div class="w-25">
                <button (click)="getReports()" type="button"
                        class="btn btn-orange ms-4 w-75 ">
                  <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M10.062 1.29175V3.71591C10.062 4.89925 11.0187 5.85842 12.202 5.86175H14.4979M9.9062 11.7988H5.4062M8.20212 8.67175H5.40545M10.281 1.30158H4.73679C3.00345 1.29491 1.58262 2.67658 1.54179 4.40908V13.3366C1.50345 15.0974 2.89929 16.5566 4.66012 16.5957C4.68595 16.5957 4.71095 16.5966 4.73679 16.5957H11.3943C13.1393 16.5249 14.5143 15.0832 14.5018 13.3366V5.69825L10.281 1.30158Z"
                      stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  Generate Report
                </button>
              </div>

              <div (click)="clearFields()" class="d-sm-block d-md-inline ms-2 mt-2"><a class=" link-blue-primary">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.16602 1.16663L12.8327 12.8333M12.8327 1.16663L1.16602 12.8333" stroke="#2196F3"
                        stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                Clear
              </a>
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>
  </form>

  <div class="row mt-3">
    <div class="col">
      <div class="inner-box">

        <div class="d-flex justify-content-between ">
          <div class="col-6">
            <h5 class="mb-3">Reports</h5>
          </div>


          <div class="col-6">
            <a class="add-new-address link-blue-primary float-end" (click)="exportToXLSX()">
              <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.4752 0.75V3.659C11.4752 5.079 12.6232 6.23 14.0432 6.234H16.7982M7 8H11M7 14H11M7 11H10M7 14V8M11.7379 0.7618H5.08493C3.00493 0.7538 1.29993 2.4118 1.25093 4.4908V15.2038C1.20493 17.3168 2.87993 19.0678 4.99293 19.1148C5.02393 19.1148 5.05393 19.1158 5.08493 19.1148H13.0739C15.1679 19.0298 16.8179 17.2998 16.8029 15.2038V6.0378L11.7379 0.7618Z"
                  stroke="#2196F3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Export to Excel
            </a>
          </div>
        </div>


        <div class="mt-4">
          <table class="table text-center">
            <thead>
            <tr>

              <th>Transaction Date</th>
              <th>Amount</th>
              <th>Payment Reference</th>
              <th>Description</th>

            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let o of getCreditsReportsData">

              <td>{{o.transactionDate}}</td>
              <td>{{o.amount.toFixed(2)}}</td>
              <td>{{o.paymentReference}}</td>
              <td>{{o.description}}</td>

            </tr>
            </tbody>

          </table>
        </div>
      </div>

    </div>

  </div>


</section>

